import { analytics } from '@saucelabs/sl-util-axios';

/**
 * @param {Object} params
 * @param {Array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getTestHealth(params) {
  return analytics.get('/overview/health', { params });
}
